import { cn } from '@workspace/ui/lib/utils'
import { ImageIcon } from 'lucide-react'
import { useState } from 'react'

export interface ImageViewerProps {
  url: string
  alt?: string
  className?: string
}

export function ImageViewer({ url, alt = 'Document preview', className }: ImageViewerProps) {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  return (
    <div className={cn('flex h-full items-center justify-center bg-zinc-900 p-4', className)}>
      {isLoading && !error && (
        <div className="absolute flex flex-col items-center gap-3 text-muted-foreground">
          <ImageIcon className="size-12 animate-pulse" />
          <span>Loading image...</span>
        </div>
      )}

      {error && (
        <div className="flex flex-col items-center gap-3 text-muted-foreground">
          <ImageIcon className="size-12" />
          <span className="text-red-400">Failed to load image</span>
        </div>
      )}

      <img
        src={url}
        alt={alt}
        className={cn('max-h-full max-w-full object-contain', isLoading && 'invisible')}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setIsLoading(false)
          setError(true)
        }}
      />
    </div>
  )
}
